import { SCRIPT_PAGE, type ScriptLayout } from './scriptLayout';
import { resolveScriptPage, type ScriptFormatSource } from './scriptFormat';

// Where each block starts, in pages from the top of page 1 (fractional), using the same
// layout the editor paginates with. Shared by the Idea outline's Script lane, Build Outline
// and the Index Cards view so page numbers agree everywhere.
export function blockStartPages(layout: ScriptLayout, format: ScriptFormatSource): Map<string, number> {
    const page = resolveScriptPage(format);
    const bodyHeight = page.rows * SCRIPT_PAGE.lineHeight;
    const starts = new Map<string, number>();
    layout.pages.forEach((p, pageIndex) => {
        for (const line of p.lines) {
            if (line.kind !== 'content' || starts.has(line.blockId)) continue;
            starts.set(line.blockId, pageIndex + Math.min(1, Math.max(0, (line.y - page.top) / bodyHeight)));
        }
    });
    return starts;
}

// 34.75 -> "35¾" (positions start at 0; people count pages from 1)
export function formatScriptPage(position: number): string {
    const page = position + 1;
    const whole = Math.floor(page + 1e-6);
    const fraction = ['', '¼', '½', '¾'][Math.round((page - whole) * 4) % 4];
    return `${whole}${fraction}`;
}
